import { StyleSheet } from 'react-native'
import theme from '../../../theme'

const styles = StyleSheet.create({
    container: {
        flex: 1,
        backgroundColor: 'white',
    },
})

export default styles
